import { useMemo } from "react";
import useClientContext from "../../contexts/useClientContext";
import useClientPageTitle from "../../contexts/useClientPageTitle";
import NewsWidget from "../news/NewsWidget";
import BalanceWidget from "./BalanceWidget";
import CashFlowsWidget from "./CashFlowsWidget";
import WidgetsPageContainer from "./WidgetsPageContainer";

const DashboardWidgetsPage = () => {
  useClientPageTitle("Dashboard");

  const { dashboardWidgets } = useClientContext();

  const { newsWidgetSettings, balanceWidgetSettings, cashFlowsWidgetSettings } = useMemo(
    () => ({
      newsWidgetSettings: dashboardWidgets.find((w) => w.predefinedType === "News"),
      balanceWidgetSettings: dashboardWidgets.find((w) => w.predefinedType === "Balance"),
      cashFlowsWidgetSettings: dashboardWidgets.find((w) => w.predefinedType === "CashFlows"),
    }),
    [dashboardWidgets]
  );

  const hasMoreThanOneWidget = balanceWidgetSettings !== undefined && cashFlowsWidgetSettings !== undefined;

  return (
    <WidgetsPageContainer showBanner>
      {newsWidgetSettings && <NewsWidget widgetSettings={newsWidgetSettings} />}

      {balanceWidgetSettings && (
        <BalanceWidget widgetSettings={balanceWidgetSettings} withFixedHeight={hasMoreThanOneWidget} />
      )}

      {cashFlowsWidgetSettings && (
        <CashFlowsWidget widgetSettings={cashFlowsWidgetSettings} withFixedHeight={hasMoreThanOneWidget} />
      )}
    </WidgetsPageContainer>
  );
};

export default DashboardWidgetsPage;
